<div class="dialog">
    <div class="modal-header">
    </div>
    <div class="modal-body">
        <div class="modal-body__message mt-4 mb-1">You’re currently offline. Please check your network connection, and
            once you’re reconnected, this message will close automatically</div>
    </div>
</div>